import { render, staticRenderFns } from "./ModalPreviewSubunidad.vue?vue&type=template&id=7fda2640&"
import script from "./ModalPreviewSubunidad.vue?vue&type=script&lang=js&"
export * from "./ModalPreviewSubunidad.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports